module.exports = __webpack_public_path__ + "img/20180815_145537_019.69119dfc.jpg";